<span class="pay-tag pay-tag--{{ severity }}">
  <lucide-icon *ngIf="direction === 'up'" name="arrow-up" [size]="10"></lucide-icon>
  <lucide-icon *ngIf="direction === 'down'" name="arrow-down" [size]="10"></lucide-icon>
  <span *ngIf="!direction && isDot" class="pay-tag__dot"></span>
  <span class="pay-tag__label">{{ value }}</span>
</span>
